import React, { useContext, useRef, useState, useEffect } from "react"; // <--- TAMBAH useEffect
import PayrollPreviewModal from "./PayrollPreviewModal";
import { validateOvertimeRules } from "../../components/utilities/OvertimeValidator";
import GlobalContext from "../../context/GlobalContext";
// TAMBAH semua fungsi API untuk CRUD dan get single
import {
  createTemplate,
  updateTemplate,
  getSingleTemplate,
  getPersonnelSchema,
  updatePersonnelSchema,
  fetchTemplatePayroll,
} from "../../api/PayrollApi";
import { fetchRegisterSuggestions } from "../../api/CompanyApi";
import swal from "../../services/swalConfig";
import BackButton from "../../components/button/BackButton";

import { tr } from "../../i18n";
// Helper function to parse query parameters from URL
const useQuery = () => {
  return new URLSearchParams(window.location.search);
};

const PayrollTemplateForm = () => {
  const { user, setLoading } = useContext(GlobalContext);

  // <--- STATE UNTUK EDIT/MODE --->
  const query = useQuery();
  const initialTemplateId = query.get("template");
  const initialPersonnelId = query.get("personnel");

  const [currentTemplateId, setCurrentTemplateId] = useState(initialTemplateId);
  const [currentPersonnelId, setCurrentPersonnelId] =
    useState(initialPersonnelId);
  const isEditMode = !!(currentTemplateId || currentPersonnelId);
  const actionName = currentPersonnelId
    ? "Personnel Schema"
    : currentTemplateId
      ? "Template"
      : "Template";
  // <--- END STATE UNTUK EDIT/MODE --->

  // Section 1: Settings State
  const [settings, setSettings] = useState({
    template_name: null,
    attendance_type: "strict",
    tolerance_minutes: 0,
    break_time_hours: 1,
    break_time_apply_to: "attendance_only",

    // DEFAULT INDONESIA
    overtime_holiday_schema: "fixed_sequence", // default
    overtime_regular_schema: "fixed_sequence", // default

    holiday_flat_multiplier: 2, // still needed if user switches schemas
    regular_flat_multiplier: 1.5,
  });

  const [regularFixedSequence, setRegularFixedSequence] = useState([
    { hour: 1, multiplier: 1.5 },
    { hour: 2, multiplier: 2 },
  ]);

  const [holidayFixedSequence, setHolidayFixedSequence] = useState([
    { type: "single", hour: 1, multiplier: 2 },
    { type: "single", hour: 2, multiplier: 3 },
    { type: "range", from: 3, to: 7, multiplier: 4 },
  ]);

  const [overtimeIncreaseRules, setOvertimeIncreaseRules] = useState([
    { after_hours: 2, multiplier: 2 },
    { after_hours: 8, multiplier: 3 },
  ]);

  //   Payroll Group
  const [payrollGroups, setPayrollGroups] = useState([
    {
      id: 1,
      name: "Base Salary",
    },
  ]);

  // Section 2: Payroll Items State
  const [payrollItems, setPayrollItems] = useState([
    {
      id: 1,
      name: "Attendance-Based Salary",
      type: "income",
      formula: "attendance_pay",
      operator: "add",
      is_taxable: true,
      group_id: 1,
    },
    {
      id: 2,
      name: "Regular Day Overtime Pay",
      type: "income",
      formula: "regular_overtime_pay",
      operator: "add",
      is_taxable: false,
      group_id: 1,
    },
    {
      id: 3,
      name: "Weekend Overtime Pay",
      type: "income",
      formula: "holiday_overtime_pay",
      operator: "add",
      is_taxable: false,
      group_id: 1,
    },
  ]);

  const [showFormulaBuilder, setShowFormulaBuilder] = useState(false);
  const [currentEditItem, setCurrentEditItem] = useState(null);
  const [formulaError, setFormulaError] = useState("");

  const [showPreview, setShowPreview] = useState(false);
  // FIX: isPreviewConfirmed HARUS default FALSE di semua mode
  const [isPreviewConfirmed, setIsPreviewConfirmed] = useState(false);
  const [holidayErrors, setHolidayErrors] = useState([]);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importSource, setImportSource] = useState("company");
  const [companyTemplateOptions, setCompanyTemplateOptions] = useState([]);
  const [countrySuggestionOptions, setCountrySuggestionOptions] = useState([]);
  const [selectedImportValue, setSelectedImportValue] = useState("");
  const [loadingImportData, setLoadingImportData] = useState(false);

  // Available variables
  const availableVariables = [
    { label: tr("payroll:attendance_pay"), value: "attendance_pay" },
    { label: tr("payroll:employee_salary_2"), value: "employee_salary" },
    { label: tr("payroll:remaining_paid_leave"), value: "remaining_paid_leave" },
    { label: tr("payroll:total_attendance_hours"), value: "total_attendance_hours" },
    { label: tr("payroll:total_attendance_days"), value: "total_attendance_days" },
    { label: tr("payroll:total_special_leave_days"), value: "total_special_leave_days" },
    {
      label: tr("payroll:holiday_overtime_pay"),
      value: "holiday_overtime_pay",
    },
    {
      label: tr("payroll:regular_overtime_pay"),
      value: "regular_overtime_pay",
    },
    {
      label: tr("payroll:holiday_overtime_hours_2"),
      value: "total_holiday_overtime_hours",
    },
    {
      label: tr("payroll:regular_overtime_hours_2"),
      value: "total_regular_overtime_hours",
    },
    { label: tr("shared:working_days"), value: "working_days" },
    { label: tr("payroll:taxable_income"), value: "taxable_income" },
    { label: tr("payroll:late_hours"), value: "late_hours" },
    { label: tr("payroll:late_minutes_2"), value: "late_minutes" },
    { label: tr("payroll:late_days"), value: "late_days" },
    { label: tr("payroll:salary_per_hour"), value: "salary_hourly_rate" },
    { label: tr("payroll:salary_per_daily"), value: "salary_daily_rate" },
    { label: tr("payroll:is_full_attendance_1_yes_0"), value: "is_full_attendance" },
    { label: tr("payroll:absent_days"), value: "absent_days" },
  ];

  const operators = ["+", "-", "*", "/", "%"];

  const [formulaBuilder, setFormulaBuilder] = useState({
    parts: [{ type: "variable", value: "attendance_pay" }],
  });

  // Handlers
  const handleSettingChange = (key, value) => {
    setSettings((prev) => ({ ...prev, [key]: value }));
  };

  const addOvertimeRule = () => {
    setOvertimeIncreaseRules([
      ...overtimeIncreaseRules,
      { after_hours: 0, multiplier: 1 },
    ]);
  };

  const removeOvertimeRule = (index) => {
    setOvertimeIncreaseRules(
      overtimeIncreaseRules.filter((_, i) => i !== index),
    );
  };

  const updateOvertimeRule = (index, field, value) => {
    const updated = [...overtimeIncreaseRules];
    updated[index][field] = parseFloat(value) || 0;
    setOvertimeIncreaseRules(updated);
  };

  //   Paygroll Group handler

  const addPayrollGroup = () => {
    const newGroup = {
      id: Date.now(),
      name: "New Group",
    };
    setPayrollGroups([...payrollGroups, newGroup]);
  };

  const updatePayrollGroup = (id, field, value) => {
    setPayrollGroups(
      payrollGroups.map((group) =>
        group.id === id ? { ...group, [field]: value } : group,
      ),
    );
  };

  const deletePayrollGroup = (id) => {
    if (payrollGroups.length === 1) {
      swal.fire({
        title: tr("shared:oops"),
        text: tr("payroll:you_must_have_at_least_one_2"),
        icon: "error",
      });
      return;
    }

    // Check if ada items di group ini
    const hasItems = payrollItems.some((item) => item.group_id === id);
    if (hasItems) {
      swal.fire({
        title: tr("shared:oops"),
        text: tr("payroll:cannot_delete_group_with_items_please"),
        icon: "error",
      });

      return;
    }

    setPayrollGroups(payrollGroups.filter((group) => group.id !== id));
  };

  // End of Payroll group handler

  const addPayrollItem = () => {
    setCurrentEditItem({
      id: Date.now(),
      name: "",
      type: "income",
      formula: "",
      operator: "add",
      is_taxable: false,
      group_id: payrollGroups[0]?.id || 1,
    });
    setFormulaBuilder({
      parts: [{ type: "variable", value: "attendance_pay" }],
    });
    setShowFormulaBuilder(true);
  };

  const editPayrollItem = (item) => {
    setCurrentEditItem({ ...item });
    setFormulaBuilder({ parts: parseFormulaToBuilder(item.formula) });
    setShowFormulaBuilder(true);
  };

  const deletePayrollItem = (id) => {
    if (payrollItems.length === 1) {
      swal.fire({
        title: tr("shared:oops"),
        text: tr("payroll:you_must_have_at_least_one"),
        icon: "error",
      });

      return;
    }
    setPayrollItems(payrollItems.filter((item) => item.id !== id));
  };

  const duplicatePayrollItem = (item) => {
    // Buat salinan item
    const newItem = {
      ...item,
      id: Date.now(), // bikin ID unik
    };

    // Cari index item asal agar duplikat muncul tepat setelahnya
    const idx = payrollItems.findIndex((i) => i.id === item.id);

    // Insert duplikat setelah item asal
    const newList = [
      ...payrollItems.slice(0, idx + 1),
      newItem,
      ...payrollItems.slice(idx + 1),
    ];

    setPayrollItems(newList);
  };

  const parseFormulaToBuilder = (formula) => {
    const parts = [];
    const tokens = formula
      .split(/(\+|\-|\*|\/|%|\(|\)|\d+\.?\d*)/g)
      .filter((t) => t.trim());

    tokens.forEach((token) => {
      const clean = token.trim();
      if (availableVariables.find((v) => v.value === clean)) {
        parts.push({ type: "variable", value: clean });
      } else if (["+", "-", "*", "/", "%"].includes(clean)) {
        parts.push({ type: "operator", value: clean });
      } else if (!isNaN(clean)) {
        parts.push({ type: "number", value: clean });
      }
    });

    return parts.length > 0
      ? parts
      : [{ type: "variable", value: "attendance_pay" }];
  };

  const buildFormulaString = () => {
    return formulaBuilder.parts
      .map((part) => {
        if (["+", "-", "*", "/", "%"].includes(part.value)) {
          // No space before %, but space around other operators
          if (part.value === "%") return part.value;
          return ` ${part.value} `;
        }
        return part.value;
      })
      .join("")
      .replace(/\s+/g, " "); // bersihkan spasi ganda
  };

  const validateFormula = (formula) => {
    if (!formula || formula.trim() === "") return "Formula cannot be empty";
    if (/[\+\-\*\/%]{2,}/.test(formula)) return "Invalid consecutive operators";

    const tokens = formula.split(/[\+\-\*\/%\(\)\s]+/);
    for (let token of tokens) {
      if (token && isNaN(token)) {
        if (!availableVariables.find((v) => v.value === token)) {
          return `Unknown variable: ${token}`;
        }
      }
    }
    return null;
  };

  const savePayrollItem = () => {
    const formula = buildFormulaString();
    const error = validateFormula(formula);

    if (error) {
      setFormulaError(error);
      return;
    }

    if (!currentEditItem.name.trim()) {
      setFormulaError("Item name is required");
      return;
    }

    const updatedItem = { ...currentEditItem, formula };

    if (payrollItems.find((item) => item.id === updatedItem.id)) {
      setPayrollItems(
        payrollItems.map((item) =>
          item.id === updatedItem.id ? updatedItem : item,
        ),
      );
    } else {
      setPayrollItems([...payrollItems, updatedItem]);
    }

    setShowFormulaBuilder(false);
    setFormulaError("");
  };

  const addFormulaPart = (type) => {
    const newPart =
      type === "variable"
        ? { type: "variable", value: "attendance_pay" }
        : type === "operator"
          ? { type: "operator", value: "+" }
          : { type: "number", value: "0" };

    setFormulaBuilder((prev) => ({
      parts: [...prev.parts, newPart],
    }));
  };

  const updateFormulaPart = (index, value) => {
    const updated = [...formulaBuilder.parts];
    updated[index].value = value;
    setFormulaBuilder({ parts: updated });
  };

  const removeFormulaPart = (index) => {
    if (formulaBuilder.parts.length === 1) return;
    setFormulaBuilder((prev) => ({
      parts: prev.parts.filter((_, i) => i !== index),
    }));
  };

  const convertHolidayRules = (seq) =>
    seq.map((rule) => {
      if (rule.to !== undefined) {
        return {
          type: "range",
          from: rule.from,
          to: rule.to,
          multiplier: rule.multiplier,
        };
      }
      return { type: "single", hour: rule.hour, multiplier: rule.multiplier };
    });

  // <--- FUNGSI BARU: SETUP STATE DARI SKEMA YANG DIMUAT --->
  const setupStateFromSchema = (schema) => {
    // 1. Settings
    setSettings((prev) => ({
      ...prev,
      ...schema.settings,
    }));

    // 2. Overtime Rules
    const {
      overtime_regular_fixed_sequence,
      overtime_holiday_fixed_sequence,
      overtime_increase_rules,
    } = schema.settings;

    if (
      overtime_regular_fixed_sequence &&
      Array.isArray(overtime_regular_fixed_sequence)
    ) {
      setRegularFixedSequence(overtime_regular_fixed_sequence);
    }

    // Holiday fixed sequence needs reverse conversion (dari format CI ke format UI)
    if (
      overtime_holiday_fixed_sequence &&
      Array.isArray(overtime_holiday_fixed_sequence)
    ) {
      const uiRules = overtime_holiday_fixed_sequence.map((rule) => {
        if (rule.type === "range") {
          return {
            type: "range",
            from: rule.from,
            to: rule.to,
            multiplier: rule.multiplier,
          };
        }
        // Asumsi type 'single'
        return { type: "single", hour: rule.hour, multiplier: rule.multiplier };
      });
      setHolidayFixedSequence(uiRules);
    }

    if (overtime_increase_rules && Array.isArray(overtime_increase_rules)) {
      setOvertimeIncreaseRules(overtime_increase_rules);
    }

    // 3. Payroll Groups & Items
    if (schema.payroll_groups && Array.isArray(schema.payroll_groups)) {
      setPayrollGroups(schema.payroll_groups);
    }
    if (schema.payroll_items && Array.isArray(schema.payroll_items)) {
      setPayrollItems(schema.payroll_items);
    }

    // FIX PENTING: JANGAN SET setIsPreviewConfirmed(true) DI SINI
    // Biarkan tetap false agar user harus mengklik "Preview" dan "Confirm" lagi.
  };
  // <--- END FUNGSI BARU --->

  const normalizeSchemaPayload = (schemaPayload) => {
    if (!schemaPayload) {
      return null;
    }

    if (typeof schemaPayload === "string") {
      try {
        return JSON.parse(schemaPayload);
      } catch (error) {
        return null;
      }
    }

    return schemaPayload;
  };

  const openImportModal = () => {
    setImportSource("company");
    setSelectedImportValue("");
    setShowImportModal(true);
  };

  const handleApplyImportSchema = () => {
    if (!selectedImportValue) {
      swal.fire(tr("shared:oops"), tr("payroll:please_choose_template_source_first"), "warning");
      return;
    }

    const selectedOption =
      importSource === "company"
        ? companyTemplateOptions.find(
            (item) => item.value === selectedImportValue,
          )
        : countrySuggestionOptions.find(
            (item) => item.value === selectedImportValue,
          );

    if (!selectedOption?.schema) {
      swal.fire(tr("shared:oops"), tr("payroll:selected_template_schema_is_not_available"), "error");
      return;
    }

    const parsedSchema = normalizeSchemaPayload(selectedOption.schema);
    if (!parsedSchema) {
      swal.fire(tr("shared:oops"), tr("payroll:cannot_read_selected_template_schema"), "error");
      return;
    }

    setupStateFromSchema(parsedSchema);
    setIsPreviewConfirmed(false);
    setShowImportModal(false);
    swal.fire(tr("shared:success_2"), tr("payroll:payroll_schema_imported_successfully"), "success");
  };

  useEffect(() => {
    const loadImportSources = async () => {
      if (!showImportModal || !user?.workspace?.company_id) {
        return;
      }

      setLoadingImportData(true);
      try {
        const [companyTemplatesResponse, countrySuggestionsResponse] =
          await Promise.all([
            fetchTemplatePayroll({
              companyId: user.workspace.company_id,
              page: 1,
              perPage: 200,
              search: "",
            }),
            fetchRegisterSuggestions(),
          ]);

        const mappedCompanyTemplates = Array.isArray(
          companyTemplatesResponse?.data,
        )
          ? companyTemplatesResponse.data.map((item) => ({
              value: `company:${item.id}`,
              label: `${item.id} - ${item.template_name || "Untitled Template"}`,
              schema: item.schema,
            }))
          : [];

        const mappedCountrySuggestions = Array.isArray(
          countrySuggestionsResponse?.data?.countries,
        )
          ? countrySuggestionsResponse.data.countries.flatMap((country) =>
              (country.payroll_options || []).map((option) => ({
                value: `country:${country.code}:${option.key}`,
                label: `${country.name || country.country_name || country.code} - ${option.label || option.key}`,
                schema: option.schema,
              })),
            )
          : [];

        setCompanyTemplateOptions(mappedCompanyTemplates);
        setCountrySuggestionOptions(mappedCountrySuggestions);

        if (mappedCompanyTemplates.length > 0) {
          setImportSource("company");
          setSelectedImportValue(mappedCompanyTemplates[0].value);
        } else if (mappedCountrySuggestions.length > 0) {
          setImportSource("country");
          setSelectedImportValue(mappedCountrySuggestions[0].value);
        }
      } catch (error) {
        swal.fire(
          tr("shared:oops"),
          tr("payroll:failed_to_load_template_sources_please"),
          "error",
        );
      } finally {
        setLoadingImportData(false);
      }
    };

    loadImportSources();
  }, [showImportModal, user?.workspace?.company_id]);

  // <--- useEffect UNTUK MEMUAT DATA AWAL --->
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        let response = null;
        let schema = null;

        if (currentTemplateId) {
          // SCENARIO 1: Load Template
          response = await getSingleTemplate(currentTemplateId);
          if (response.data && response.data.schema) {
            schema = response.data.schema;
          }
        } else if (currentPersonnelId) {
          // SCENARIO 2: Load Personnel Schema
          if (!user?.workspace?.company_id)
            throw new Error("Company ID not available.");
          response = await getPersonnelSchema(
            currentPersonnelId,
            user.workspace.company_id,
          );
          if (response.data && response.data.schema) {
            schema = response.data.schema;
          }
        }

        if (schema) {
          setupStateFromSchema(schema);
        } else if (isEditMode) {
          swal.fire(
            tr("shared:error"),
            tr("payroll:schema_for_actionname_not_found_starting", { actionName }),
            "warning",
          );
        }
      } catch (error) {
        console.error("Error loading payroll schema:", error);
        swal.fire(
          tr("shared:error"),
          tr("payroll:failed_to_load_actionname_value", { actionName, value: error.message || "Unknown error" }),
          "error",
        );
        setCurrentTemplateId(null);
        setCurrentPersonnelId(null);
      } finally {
        setLoading(false);
      }
    };

    if (isEditMode && user?.workspace?.company_id) {
      loadData();
    }
  }, [
    currentTemplateId,
    currentPersonnelId,
    user?.workspace?.company_id,
    isEditMode,
    actionName,
    setLoading,
  ]);
  // <--- END useEffect --->

  // START: MODIFIKASI handleSubmit FUNCTION
  const handleSubmit = async () => {
    // 1. Validation (tetap sama)
    if (!settings.template_name || settings.template_name.trim() === "") {
      swal.fire({
        title: tr("shared:oops"),
        text: tr("payroll:template_name_cannot_be_empty"),
        icon: "error",
      });
      return;
    }

    if (!isPreviewConfirmed) {
      swal.fire({
        title: tr("shared:oops"),
        text: tr("payroll:please_preview_and_confirm_the_template_2"),
        icon: "error",
      });
      return;
    }

    // 2. Prepare Template Data (tetap sama)
    const templateData = {
      settings: {
        ...settings,
        template_name: settings.template_name.trim(),
        overtime_increase_rules:
          settings.overtime_holiday_schema === "increasing"
            ? overtimeIncreaseRules
            : [],
        overtime_regular_fixed_sequence:
          settings.overtime_regular_schema === "fixed_sequence"
            ? regularFixedSequence
            : [],
        overtime_holiday_fixed_sequence:
          settings.overtime_holiday_schema === "fixed_sequence"
            ? convertHolidayRules(holidayFixedSequence)
            : [],
      },
      payroll_groups: payrollGroups,
      payroll_items: payrollItems,
    };

    // 3. Tentukan API Call dan Payload (tetap sama)
    let payload = {
      company_id: user?.workspace?.company_id,
      template_settings: templateData,
    };

    let apiCall = createTemplate;
    let successMessage = "Payroll Template created successfully!";

    if (currentPersonnelId) {
      // SCENARIO 3: Update Personnel Schema
      payload = {
        personnel_id: currentPersonnelId,
        company_id: user?.workspace?.company_id,
        template_settings: templateData,
      };
      apiCall = updatePersonnelSchema;
      successMessage = "Personnel Payroll Schema updated successfully!";
    } else if (currentTemplateId) {
      // SCENARIO 2: Update Existing Template
      payload = {
        ...payload,
        id: currentTemplateId, // Tambahkan ID untuk update API
      };
      apiCall = updateTemplate;
      successMessage = "Payroll Template updated successfully!";
    }

    // 4. API Call
    setLoading(true);
    try {
      // TANGKAP RESPONSE UNTUK MENGAMBIL ID BARU
      const response = await apiCall(payload);

      // LOGIKA BARU UNTUK CREATE TEMPLATE (SCENARIO 1)
      if (apiCall === createTemplate && response.status === 200) {
        const newTemplateId = response.template_id;

        // 1. Ubah URL di browser tanpa reload penuh
        const newUrl = `${window.location.pathname}?template=${newTemplateId}`;
        window.history.pushState({ path: newUrl }, "", newUrl);

        // 2. Update state untuk bertransisi ke mode Edit
        setCurrentTemplateId(newTemplateId);

        // 3. Reset konfirmasi preview untuk memaksa user konfirmasi lagi
        setIsPreviewConfirmed(false);

        swal.fire(tr("shared:success_2"), successMessage, "success");
      } else {
        // LOGIKA UNTUK UPDATE TEMPLATE ATAU PERSONNEL (SCENARIO 2 & 3)
        swal.fire(tr("shared:success_2"), successMessage, "success");
        // Setelah update, harus preview ulang sebelum update berikutnya
        setIsPreviewConfirmed(false);
      }
    } catch (error) {
      console.error("Error saving/updating template:", error);
      swal.fire(
        tr("shared:error"),
        tr("payroll:failed_to_save_update_actionname_value", { actionName, value: error.response?.data?.message || error.message || "Unknown error" }),
        "error",
      );
    } finally {
      setLoading(false);
    }
  };
  // END: MODIFIKASI handleSubmit FUNCTION

  //   Handle preview
  const handlePreview = () => {
    setShowPreview(true);
  };

  const handlePreviewConfirm = () => {
    setIsPreviewConfirmed(true);
    setShowPreview(false);

    swal.fire({
      title: "",
      text: tr("payroll:preview_confirmed_you_can_now_save"),
      icon: "success",
    });
  };

  //   Dragable order section
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);

  const onDragStart = (e, position) => {
    dragItem.current = position;
    // optional: set drag image
    e.dataTransfer.effectAllowed = "move";
  };

  const onDragEnter = (e, position, targetGroupId) => {
    dragOverItem.current = { position, targetGroupId };
  };

  const onDragOver = (e) => {
    e.preventDefault(); // perlu agar drop bisa terjadi
  };

  const onDrop = (e) => {
    e.preventDefault();

    const dragIndex = dragItem.current;
    const { position: hoverIndex, targetGroupId } = dragOverItem.current;

    const items = [...payrollItems];
    const draggedItem = items[dragIndex];

    // --- JIKA PINDAH GROUP ---
    if (draggedItem.group_id !== targetGroupId) {
      draggedItem.group_id = targetGroupId;
    }

    // Hapus dari posisi lama
    items.splice(dragIndex, 1);

    // Masukkan ke posisi baru
    items.splice(hoverIndex, 0, draggedItem);

    setPayrollItems(items);

    dragItem.current = null;
    dragOverItem.current = null;
  };

  return (
    <div className="container py-4">
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        rel="stylesheet"
      />

      {/* SECTION 1 */}
      <div className="card mb-4 shadow-sm">
        <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            {isEditMode ? `Edit ${actionName}` : tr("payroll:new_payroll_template")}
          </h5>
          <button className="btn btn-light btn-sm" onClick={openImportModal}>
            <i className="fas fa-upload me-2"></i>
            {tr("payroll:import_template")}
          </button>
        </div>
        <div className="card-body">
          <div className="row mb-3">
            <div className="col-md-12">
              <label className="form-label">
                <h6>{tr("shared:payroll_name")}</h6>
              </label>
              <input
                type="text"
                className="form-control"
                min="0"
                placeholder={tr("payroll:eg_default_payroll_template")}
                value={settings.template_name || ""}
                onChange={(e) =>
                  handleSettingChange("template_name", e.target.value)
                }
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label">
                <h6>{tr("payroll:attendance_type_2")}</h6>
              </label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="attendance_type"
                    checked={settings.attendance_type === "strict"}
                    onChange={() =>
                      handleSettingChange("attendance_type", "strict")
                    }
                  />
                  <label className="form-check-label">{tr("payroll:strict")}</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="attendance_type"
                    checked={settings.attendance_type === "flexible"}
                    onChange={() =>
                      handleSettingChange("attendance_type", "flexible")
                    }
                  />
                  <label className="form-check-label">{tr("payroll:flexible")}</label>
                </div>
              </div>
            </div>

            {settings.attendance_type === "strict" && (
              <div className="col-md-6">
                <label className="form-label">
                  <h6>{tr("payroll:tolerance_in_minutes")}</h6>
                </label>
                <input
                  type="number"
                  className="form-control"
                  min="0"
                  value={settings.tolerance_minutes}
                  onChange={(e) =>
                    handleSettingChange(
                      "tolerance_minutes",
                      parseInt(e.target.value) || 0,
                    )
                  }
                />
                <small className="text-muted">{tr("payroll:set_0_for_no_tolerance")}</small>
              </div>
            )}
          </div>

          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label">
                <h6>{tr("payroll:break_time_hours")}</h6>
              </label>
              <input
                type="number"
                className="form-control"
                min="0"
                step="0.5"
                value={settings.break_time_hours}
                onChange={(e) =>
                  handleSettingChange(
                    "break_time_hours",
                    parseFloat(e.target.value) || 0,
                  )
                }
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">
                <h6>{tr("payroll:apply_break_time_to")}</h6>
              </label>
              <select
                className="form-select"
                value={settings.break_time_apply_to}
                onChange={(e) =>
                  handleSettingChange("break_time_apply_to", e.target.value)
                }
              >
                <option value="all">{tr("payroll:all_attendance_overtime")}</option>
                <option value="attendance_only">{tr("payroll:attendance_only")}</option>
              </select>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="row mb-3">
                <div className="col-md-12">
                  <label className="form-label">
                    <h6>{tr("payroll:overtime_at_holiday_schema")}</h6>
                  </label>
                  <div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="overtime_schema"
                        checked={
                          settings.overtime_holiday_schema === "fixed_sequence"
                        }
                        onChange={() =>
                          handleSettingChange(
                            "overtime_holiday_schema",
                            "fixed_sequence",
                          )
                        }
                      />
                      <label className="form-check-label">
                        {tr("payroll:fixed_sequence_standard")}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="overtime_schema"
                        checked={settings.overtime_holiday_schema === "flat"}
                        onChange={() =>
                          handleSettingChange("overtime_holiday_schema", "flat")
                        }
                      />
                      <label className="form-check-label">{tr("payroll:flat_rate")}</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="overtime_schema"
                        checked={
                          settings.overtime_holiday_schema === "increasing"
                        }
                        onChange={() =>
                          handleSettingChange(
                            "overtime_holiday_schema",
                            "increasing",
                          )
                        }
                      />
                      <label className="form-check-label">
                        {tr("payroll:increasing_multiplier")}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {settings.overtime_holiday_schema === "flat" && (
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">
                      {tr("payroll:holiday_flat_multiplier")}
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      min="1"
                      step="0.1"
                      value={settings.holiday_flat_multiplier}
                      onChange={(e) =>
                        handleSettingChange(
                          "holiday_flat_multiplier",
                          parseFloat(e.target.value) || 1,
                        )
                      }
                    />
                    <small className="text-muted">
                      {tr("payroll:default_2x_sesuai_aturan_indonesia")}
                    </small>
                  </div>
                </div>
              )}

              {settings.overtime_holiday_schema === "fixed_sequence" && (
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <label className="form-label mb-0">
                        {tr("payroll:holiday_overtime_fixed_sequence")}
                      </label>
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() =>
                          setHolidayFixedSequence((prev) => [
                            ...prev,
                            { hour: prev.length + 1, multiplier: 1 },
                          ])
                        }
                      >
                        <i className="fas fa-plus"></i> {" "}{tr("payroll:add_tier")}
                      </button>
                    </div>

                    <table>
                      <thead className="table-light">
                        <tr>
                          <th>{tr("payroll:hour_range_2")}</th>
                          <th>{tr("payroll:multiplier")}</th>
                          <th width="80">{tr("payroll:action")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {holidayFixedSequence.map((rule, index) => (
                          <tr key={index}>
                            {/* COLUMN: Hour / Range */}
                            <td style={{ minWidth: "240px" }}>
                              {/* Rule Type Selector */}
                              <select
                                className="form-select form-select-sm mb-2"
                                value={
                                  rule.type || (rule.to ? "range" : "single")
                                }
                                onChange={(e) => {
                                  const updated = [...holidayFixedSequence];
                                  const newType = e.target.value;

                                  if (newType === "single") {
                                    updated[index] = {
                                      type: "single",
                                      hour: rule.hour || rule.from || 1,
                                      multiplier: rule.multiplier ?? 1,
                                    };
                                  } else {
                                    updated[index] = {
                                      type: "range",
                                      from: rule.from || rule.hour || 1,
                                      to:
                                        rule.to ||
                                        (rule.hour ? rule.hour + 1 : 2),
                                      multiplier: rule.multiplier ?? 1,
                                    };
                                  }

                                  setHolidayFixedSequence(updated);
                                }}
                              >
                                <option value="single">{tr("payroll:single_hour")}</option>
                                <option value="range">{tr("payroll:hour_range")}</option>
                              </select>

                              {/* SINGLE HOUR INPUT */}
                              {(rule.type === "single" ||
                                (!rule.type && !rule.to)) && (
                                <input
                                  type="number"
                                  className="form-control form-control-sm"
                                  placeholder={tr("payroll:hour")}
                                  value={rule.hour}
                                  min="1"
                                  onChange={(e) => {
                                    const updated = [...holidayFixedSequence];
                                    updated[index].hour =
                                      parseInt(e.target.value) || 1;
                                    setHolidayFixedSequence(updated);

                                    // Jalankan validasi real-time
                                    const converted =
                                      convertHolidayRules(updated);
                                    const errors =
                                      validateOvertimeRules(converted);
                                    setHolidayErrors(errors);
                                  }}
                                />
                              )}

                              {/* RANGE INPUT */}
                              {(rule.type === "range" ||
                                (!rule.type && rule.to)) && (
                                <div className="d-flex gap-2">
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    placeholder={tr("shared:from")}
                                    min="1"
                                    value={rule.from}
                                    onChange={(e) => {
                                      const updated = [...holidayFixedSequence];
                                      updated[index].from =
                                        parseInt(e.target.value) || 1;
                                      setHolidayFixedSequence(updated);

                                      const converted =
                                        convertHolidayRules(updated);
                                      const errors =
                                        validateOvertimeRules(converted);
                                      setHolidayErrors(errors);
                                    }}
                                  />

                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    placeholder={tr("shared:to")}
                                    min={rule.from}
                                    value={rule.to}
                                    onChange={(e) => {
                                      const updated = [...holidayFixedSequence];
                                      updated[index].to =
                                        parseInt(e.target.value) ||
                                        updated[index].from;
                                      setHolidayFixedSequence(updated);

                                      const converted =
                                        convertHolidayRules(updated);
                                      const errors =
                                        validateOvertimeRules(converted);
                                      setHolidayErrors(errors);
                                    }}
                                  />
                                </div>
                              )}
                            </td>

                            {/* COLUMN: Multiplier */}
                            <td>
                              <input
                                type="number"
                                step="0.1"
                                className="form-control form-control-sm"
                                placeholder={tr("payroll:multiplier")}
                                value={rule.multiplier}
                                onChange={(e) => {
                                  const updated = [...holidayFixedSequence];
                                  updated[index].multiplier =
                                    parseFloat(e.target.value) || 1;
                                  setHolidayFixedSequence(updated);
                                }}
                              />
                            </td>

                            {/* COLUMN: Action */}
                            <td className="text-center">
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() =>
                                  setHolidayFixedSequence((prev) =>
                                    prev.filter((_, i) => i !== index),
                                  )
                                }
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {holidayErrors.length > 0 && (
                      <div className="alert alert-danger mt-2 py-2">
                        {holidayErrors.map((err, i) => (
                          <div key={i} style={{ fontSize: "13px" }}>
                            {err.message}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {settings.overtime_holiday_schema === "increasing" && (
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <label className="form-label mb-0">
                        {tr("payroll:overtime_increase_rules")}
                      </label>
                      <button
                        className="btn btn-success btn-sm"
                        onClick={addOvertimeRule}
                      >
                        <i className="fas fa-plus"></i> {" "}{tr("payroll:add_rule")}
                      </button>
                    </div>
                    <table>
                      <thead className="table-light">
                        <tr>
                          <th>{tr("payroll:increase_after_hours")}</th>
                          <th>{tr("payroll:multiplier")}</th>
                          <th width="80">{tr("payroll:action")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {overtimeIncreaseRules.map((rule, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                min="0"
                                step="0.5"
                                value={rule.after_hours}
                                onChange={(e) =>
                                  updateOvertimeRule(
                                    index,
                                    "after_hours",
                                    e.target.value,
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                min="1"
                                step="0.1"
                                value={rule.multiplier}
                                onChange={(e) =>
                                  updateOvertimeRule(
                                    index,
                                    "multiplier",
                                    e.target.value,
                                  )
                                }
                              />
                            </td>
                            <td className="text-center">
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => removeOvertimeRule(index)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
            <div className="col-12">
              <label className="form-label mt-4">
                <h6>{tr("payroll:regular_overtime_schema")}</h6>
              </label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="regular_overtime_schema"
                    checked={
                      settings.overtime_regular_schema === "fixed_sequence"
                    }
                    onChange={() =>
                      handleSettingChange(
                        "overtime_regular_schema",
                        "fixed_sequence",
                      )
                    }
                  />
                  <label className="form-check-label">
                    {tr("payroll:fixed_sequence_standard")}
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="regular_overtime_schema"
                    checked={settings.overtime_regular_schema === "flat"}
                    onChange={() =>
                      handleSettingChange("overtime_regular_schema", "flat")
                    }
                  />
                  <label className="form-check-label">{tr("payroll:flat_rate")}</label>
                </div>
              </div>

              {settings.overtime_regular_schema === "flat" && (
                <div className="row mb-3 mt-3">
                  <div className="col-md-6">
                    <label className="form-label">
                      {tr("payroll:regular_flat_multiplier")}
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      min="1"
                      step="0.1"
                      value={settings.regular_flat_multiplier}
                      onChange={(e) =>
                        handleSettingChange(
                          "regular_flat_multiplier",
                          parseFloat(e.target.value) || 1,
                        )
                      }
                    />
                  </div>
                </div>
              )}

              {settings.overtime_regular_schema === "fixed_sequence" && (
                <div className="row mb-3">
                  <div className="col-md-12">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <label className="form-label mb-0">
                        {tr("payroll:regular_overtime_fixed_sequence")}
                      </label>
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() =>
                          setRegularFixedSequence((prev) => [
                            ...prev,
                            { hour: prev.length + 1, multiplier: 1 },
                          ])
                        }
                      >
                        <i className="fas fa-plus"></i> {" "}{tr("payroll:add_tier")}
                      </button>
                    </div>

                    <table>
                      <thead className="table-light">
                        <tr>
                          <th>{tr("payroll:hour")}</th>
                          <th>{tr("payroll:multiplier")}</th>
                          <th width="80">{tr("payroll:action")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {regularFixedSequence.map((rule, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                min="1"
                                value={rule.hour}
                                onChange={(e) => {
                                  const updated = [...regularFixedSequence];
                                  updated[index].hour =
                                    parseInt(e.target.value) || 1;
                                  setRegularFixedSequence(updated);
                                }}
                              />
                            </td>

                            <td>
                              <input
                                type="number"
                                step="0.1"
                                className="form-control form-control-sm"
                                value={rule.multiplier}
                                onChange={(e) => {
                                  const updated = [...regularFixedSequence];
                                  updated[index].multiplier =
                                    parseFloat(e.target.value) || 1;
                                  setRegularFixedSequence(updated);
                                }}
                              />
                            </td>

                            <td className="text-center">
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() =>
                                  setRegularFixedSequence((prev) =>
                                    prev.filter((_, i) => i !== index),
                                  )
                                }
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* SECTION 2 */}
      <div className="card shadow-sm">
        <div className="card-header bg-success text-white">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">{tr("payroll:payroll_calculation_items")}</h5>
            <button className="btn btn-light btn-sm" onClick={addPayrollItem}>
              <i className="fas fa-plus"></i> {" "}{tr("payroll:add_item")}
            </button>
          </div>
        </div>
        <div className="card-body">
          {/* Payroll group UI */}

          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="mb-0">
                <i className="fas fa-layer-group me-2"></i>
                {tr("payroll:manage_groups_sections")}
              </h6>
              <button
                className="btn btn-success btn-sm"
                onClick={addPayrollGroup}
              >
                <i className="fas fa-plus"></i> {" "}{tr("payroll:add_group")}
              </button>
            </div>

            <div className="row g-2">
              {payrollGroups.map((group) => (
                <div key={group.id} className="col-md-6">
                  <div className="card">
                    <div className="card-body p-2">
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={group.name}
                          onChange={(e) =>
                            updatePayrollGroup(group.id, "name", e.target.value)
                          }
                          placeholder={tr("payroll:group_name")}
                        />
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => deletePayrollGroup(group.id)}
                          disabled={payrollGroups.length === 1}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </div>
                      <small className="text-muted">
                        {
                          payrollItems.filter((i) => i.group_id === group.id)
                            .length
                        }{" "}
                        {tr("payroll:items")}
                      </small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* End of group UI */}

          <div className="alert alert-info">
            <i className="fas fa-info-circle me-2"></i>
            {tr("payroll:items_are_calculated_from_top_to")}
          </div>

          {payrollGroups.map((group) => {
            const groupItems = payrollItems.filter(
              (item) => item.group_id === group.id,
            );
            if (groupItems.length === 0) return null;

            return (
              <div key={group.id} className="mb-4">
                <div className="d-flex align-items-center mb-2">
                  <h6 className="mb-0 text-primary">
                    <i className="fas fa-folder-open me-2"></i>
                    {group.name}
                  </h6>
                  <span className="badge bg-secondary ms-2">
                    {groupItems.length} {" "}{tr("payroll:items")}
                  </span>
                </div>

                <table>
                  <thead className="table-light">
                    <tr>
                      <th width="30"></th>
                      <th>{tr("payroll:item_name")}</th>
                      <th>{tr("payroll:type")}</th>
                      <th>{tr("payroll:formula")}</th>
                      <th>{tr("payroll:operator_2")}</th>
                      <th width="120">{tr("shared:actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupItems.map((item) => {
                      const globalIndex = payrollItems.findIndex(
                        (i) => i.id === item.id,
                      );
                      return (
                        <tr
                          key={item.id}
                          draggable
                          onDragStart={(e) => onDragStart(e, globalIndex)}
                          onDragEnter={(e) =>
                            onDragEnter(e, globalIndex, group.id)
                          }
                          onDragOver={onDragOver}
                          onDrop={onDrop}
                        >
                          <td className="text-center">
                            <i
                              className="fas fa-grip-vertical text-muted"
                              style={{ cursor: "grab" }}
                            ></i>
                          </td>
                          <td>
                            <strong>{item.name}</strong>
                            {item.is_taxable && (
                              <span className="badge bg-warning ms-2">
                                {tr("payroll:taxable")}
                              </span>
                            )}
                          </td>
                          <td>
                            <span
                              className={`badge bg-${
                                item.type === "income" ? "success" : "danger"
                              }`}
                            >
                              {item.type === "income" ? tr("payroll:income") : tr("payroll:deduction")}
                            </span>
                          </td>
                          <td>
                            <code className="text-primary">{item.formula}</code>
                          </td>
                          <td>
                            <span
                              className={`badge bg-${
                                item.operator === "add"
                                  ? "primary"
                                  : "secondary"
                              }`}
                            >
                              {item.operator === "add"
                                ? tr("payroll:add")
                                : tr("payroll:subtract")}
                            </span>
                          </td>
                          <td>
                            <button
                              className="btn btn-outline-primary btn-sm me-1"
                              onClick={() => editPayrollItem(item)}
                            >
                              {tr("common:breadcrumb.edit")}
                            </button>

                            <button
                              className="btn btn-outline-secondary btn-sm me-1"
                              onClick={() => duplicatePayrollItem(item)}
                            >
                              {tr("payroll:duplicate")}
                            </button>

                            <button
                              className="btn btn-outline-danger btn-sm me-1"
                              onClick={() => deletePayrollItem(item.id)}
                              disabled={payrollItems.length === 1}
                            >
                              {tr("common:actions.delete")}
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            );
          })}
        </div>
      </div>

      {/* Modal */}
      {showFormulaBuilder && (
        <>
          <div
            className="modal show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {currentEditItem?.id &&
                    payrollItems.find((i) => i.id === currentEditItem.id)
                      ? tr("common:breadcrumb.edit")
                      : tr("payroll:add_2")}{" "}
                    {tr("payroll:payroll_item")}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowFormulaBuilder(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  {formulaError && (
                    <div className="alert alert-danger alert-dismissible fade show">
                      {formulaError}
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setFormulaError("")}
                      ></button>
                    </div>
                  )}

                  <div className="mb-3">
                    <label className="form-label">{tr("payroll:item_name_2")}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={currentEditItem?.name || ""}
                      onChange={(e) =>
                        setCurrentEditItem({
                          ...currentEditItem,
                          name: e.target.value,
                        })
                      }
                      placeholder={tr("payroll:e_g_transportation_allowance")}
                    />
                  </div>

                  {/* Group Input */}

                  <div className="mb-3">
                    <label className="form-label">{tr("payroll:group_section")}</label>
                    <select
                      className="form-select"
                      value={currentEditItem?.group_id || payrollGroups[0]?.id}
                      onChange={(e) =>
                        setCurrentEditItem({
                          ...currentEditItem,
                          group_id: parseInt(e.target.value),
                        })
                      }
                    >
                      {payrollGroups.map((g) => (
                        <option key={g.id} value={g.id}>
                          {g.name}
                        </option>
                      ))}
                    </select>
                    <small className="text-muted">
                      {tr("payroll:select_which_group_this_item_belongs")}
                    </small>
                  </div>

                  {/* EOF Group Input */}

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">{tr("payroll:type")}</label>
                      <div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            checked={currentEditItem?.type === "income"}
                            onChange={() =>
                              setCurrentEditItem({
                                ...currentEditItem,
                                type: "income",
                              })
                            }
                          />
                          <label className="form-check-label">{tr("payroll:income")}</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            checked={currentEditItem?.type === "deduction"}
                            onChange={() =>
                              setCurrentEditItem({
                                ...currentEditItem,
                                type: "deduction",
                              })
                            }
                          />
                          <label className="form-check-label">{tr("payroll:deduction")}</label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">
                        {tr("payroll:operator_for_next_item")}
                      </label>
                      <div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            checked={currentEditItem?.operator === "add"}
                            onChange={() =>
                              setCurrentEditItem({
                                ...currentEditItem,
                                operator: "add",
                              })
                            }
                          />
                          <label className="form-check-label">{tr("payroll:add")}</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            checked={currentEditItem?.operator === "subtract"}
                            onChange={() =>
                              setCurrentEditItem({
                                ...currentEditItem,
                                operator: "subtract",
                              })
                            }
                          />
                          <label className="form-check-label">
                            {tr("payroll:subtract")}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={currentEditItem?.is_taxable || false}
                        onChange={(e) =>
                          setCurrentEditItem({
                            ...currentEditItem,
                            is_taxable: e.target.checked,
                          })
                        }
                      />
                      <label className="form-check-label">
                        {tr("payroll:is_taxable_income")}
                      </label>
                    </div>
                  </div>

                  <label className="form-label">{tr("payroll:formula_builder")}</label>
                  <div className="card mb-3">
                    <div className="card-body">
                      <div className="d-flex flex-wrap gap-2 mb-3">
                        {formulaBuilder.parts.map((part, index) => (
                          <div
                            key={index}
                            className="input-group"
                            style={{ width: "auto" }}
                          >
                            {part.type === "variable" && (
                              <select
                                className="form-select"
                                value={part.value}
                                onChange={(e) =>
                                  updateFormulaPart(index, e.target.value)
                                }
                                style={{ minWidth: "200px" }}
                              >
                                {availableVariables.map((v) => (
                                  <option key={v.value} value={v.value}>
                                    {v.label}
                                  </option>
                                ))}
                              </select>
                            )}
                            {part.type === "operator" && (
                              <select
                                className="form-select"
                                value={part.value}
                                onChange={(e) =>
                                  updateFormulaPart(index, e.target.value)
                                }
                                style={{ width: "80px" }}
                              >
                                {operators.map((op) => (
                                  <option key={op} value={op}>
                                    {op}
                                  </option>
                                ))}
                              </select>
                            )}
                            {part.type === "number" && (
                              <input
                                type="text"
                                className="form-control"
                                value={part.value}
                                onChange={(e) =>
                                  updateFormulaPart(index, e.target.value)
                                }
                                style={{ width: "100px" }}
                                placeholder="0"
                              />
                            )}
                            <button
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => removeFormulaPart(index)}
                              disabled={formulaBuilder.parts.length === 1}
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          </div>
                        ))}
                      </div>

                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={() => addFormulaPart("variable")}
                        >
                          {tr("payroll:variable")}
                        </button>
                        <button
                          className="btn btn-outline-secondary btn-sm"
                          onClick={() => addFormulaPart("operator")}
                        >
                          {tr("payroll:operator")}
                        </button>
                        <button
                          className="btn btn-outline-info btn-sm"
                          onClick={() => addFormulaPart("number")}
                        >
                          {tr("payroll:number")}
                        </button>
                      </div>

                      <div className="mt-3 p-2 bg-light border rounded">
                        <strong>{tr("payroll:preview")}</strong>{" "}
                        <code>{buildFormulaString()}</code>
                      </div>
                    </div>
                  </div>

                  <div
                    className="alert alert-secondary"
                    style={{ fontSize: "10pt" }}
                  >
                    <strong>{tr("payroll:available_variables")}</strong>
                    <ul className="mb-0 mt-2" style={{ columnCount: 2 }}>
                      {availableVariables.map((v) => (
                        <li key={v.value}>
                          <code>{v.value}</code> - {v.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowFormulaBuilder(false)}
                  >
                    {tr("common:actions.cancel")}
                  </button>
                  <button className="btn btn-primary" onClick={savePayrollItem}>
                    <i className="fas fa-check"></i> {" "}{tr("payroll:save_item")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {showImportModal && (
        <div
          className="modal d-block"
          style={{ background: "rgba(0,0,0,0.5)" }}
          onClick={() => setShowImportModal(false)}
        >
          <div
            className="modal-dialog modal-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{tr("payroll:import_payroll_template")}</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowImportModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">{tr("payroll:import_source")}</label>
                  <div className="d-flex gap-3">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="import_source"
                        id="import-source-company"
                        checked={importSource === "company"}
                        onChange={() => {
                          setImportSource("company");
                          setSelectedImportValue(
                            companyTemplateOptions[0]?.value || "",
                          );
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="import-source-company"
                      >
                        {tr("payroll:company_payroll_templates")}
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="import_source"
                        id="import-source-country"
                        checked={importSource === "country"}
                        onChange={() => {
                          setImportSource("country");
                          setSelectedImportValue(
                            countrySuggestionOptions[0]?.value || "",
                          );
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="import-source-country"
                      >
                        {tr("payroll:country_suggestions")}
                      </label>
                    </div>
                  </div>
                </div>

                <div>
                  <label className="form-label">{tr("payroll:choose_template_2")}</label>
                  <select
                    className="form-select"
                    value={selectedImportValue}
                    onChange={(e) => setSelectedImportValue(e.target.value)}
                    disabled={loadingImportData}
                  >
                    <option value="">{tr("payroll:select_template")}</option>
                    {(importSource === "company"
                      ? companyTemplateOptions
                      : countrySuggestionOptions
                    ).map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                  {importSource === "company" &&
                  companyTemplateOptions.length === 0 ? (
                    <small className="text-muted d-block mt-2">
                      {tr("payroll:no_company_payroll_templates_found")}
                    </small>
                  ) : null}
                  {importSource === "country" &&
                  countrySuggestionOptions.length === 0 ? (
                    <small className="text-muted d-block mt-2">
                      {tr("payroll:no_country_payroll_suggestions_available")}
                    </small>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setShowImportModal(false)}
                >
                  {tr("common:actions.close")}
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleApplyImportSchema}
                  disabled={loadingImportData}
                >
                  <i className="fas fa-file-import me-2"></i>
                  {tr("common:breadcrumb.import")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Submit */}

      <div className="text-end mt-4">
        <div className="d-flex justify-content-between align-items-center mt-4">
          {/* LEFT - Back Button */}
          <BackButton url={"/payroll?tab=template"} />

          {/* RIGHT - Action Buttons */}
          <div className="d-flex justify-content-end gap-2 align-items-center">
            {isPreviewConfirmed && (
              <span className="badge bg-success p-2">
                <i className="fas fa-check-circle me-1"></i>
                {tr("payroll:preview_confirmed")}
              </span>
            )}

            <button className="btn btn-info btn-md" onClick={handlePreview}>
              <i className="fas fa-eye me-2"></i>
              {tr("payroll:preview_calculation")}
            </button>

            <button
              className="btn btn-primary btn-md"
              onClick={handleSubmit}
              disabled={!isPreviewConfirmed}
            >
              <i
                className={`fas fa-${isEditMode ? "sync-alt" : "save"} me-2`}
              ></i>
              {isEditMode ? `Update ${actionName}` : tr("payroll:save_payroll_template")}
            </button>
          </div>
        </div>

        {!isPreviewConfirmed && (
          <small className="text-muted d-block mt-2">
            <i className="fas fa-info-circle me-1"></i>
            {tr("payroll:please_preview_and_confirm_the_template")}
          </small>
        )}

        <PayrollPreviewModal
          show={showPreview}
          onClose={() => setShowPreview(false)}
          onConfirm={handlePreviewConfirm}
          template={{
            settings: {
              ...settings,
              overtime_increase_rules:
                settings.overtime_holiday_schema === "increasing"
                  ? overtimeIncreaseRules
                  : [],

              overtime_holiday_fixed_sequence:
                settings.overtime_holiday_schema === "fixed_sequence"
                  ? convertHolidayRules(holidayFixedSequence)
                  : [],

              overtime_regular_fixed_sequence:
                settings.overtime_regular_schema === "fixed_sequence"
                  ? regularFixedSequence
                  : [],
            },

            payroll_groups: payrollGroups,
            payroll_items: payrollItems,
          }}
        />
      </div>
    </div>
  );
};

export default PayrollTemplateForm;
